<template>
  <div class="container">
    <div id="header">
      <div  class="flex flex-row-left  margin-top-20 ">
        <div class="flex-item-center">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="销售订单号">
              <el-input style="width:200px" v-model="formInline.saleOrder" placeholder="马帮订单号,交易号" clearable />
            </el-form-item>
            <el-form-item label="产品相关">
              <el-input style="width:200px" v-model="formInline.materialNo" placeholder="产品SKU,名称" clearable />
            </el-form-item>
            <el-form-item label="付款时间">
              <el-date-picker
                  value-format="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  v-model="formInline.startMonth"
                  type="date"
                  placeholder="付款时间"
                  clearable
              />
              -
              <el-date-picker
                  value-format="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  v-model="formInline.endMonth"
                  type="date"
                  placeholder="付款时间"
                  clearable
              />
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select
                  clearable
                  @clear="formInline.status=''"
                  v-model="formInline.status"
                  :reserve-keyword="false"
                  placeholder="订单状态"
                  style="width: 200px"
              >
                <el-option
                    v-for="item in defaultOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button type="warning" @click="fetchLatestOrders" style="margin-left: 10px;">拉单</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>
    <div class="margin-20-0">
      <div class="table">
        <!---->
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            v-loading="loading"
        >
          <template #empty>
            <div class="table-empty">
              <span>暂无数据</span>
              <el-button type="primary" size="small" @click="fetchLatestOrders" style="margin-left: 20px;">拉取最新订单</el-button>
            </div>
          </template>
          <el-table-column
              label="马帮订单编码"
              min-width="100"
              prop="platformOrder"
          ></el-table-column>
          <el-table-column
              label="交易号"
              min-width="100"
              prop="salesRecordNumber"
          ></el-table-column>
          <el-table-column
              label="出库单号"
              min-width="100"
              prop="riiNumber"
          ></el-table-column>
          <el-table-column
              label="下推RII人"
              min-width="100"
              prop="createUser"
          ></el-table-column>
          <el-table-column
              label="物流单号"
              min-width="100"
              prop="trackNumber"
          ></el-table-column>
          <el-table-column
              label="产品SKu"
              min-width="100"
              prop="materNum"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="materName"
          ></el-table-column>
          <el-table-column
              class="center"
              label="产品图片"
              width="175"
              prop="pictureUrl"
          >
            <template #default="scope">
              <MyImage :picture-url="scope.row.pictureUrl" :picture-url-list="[scope.row.pictureUrl] "></MyImage>
            </template>
          </el-table-column>
          <el-table-column
              label="产品数量"
              min-width="50"
              prop="Quantity"
          >
          </el-table-column>
          <el-table-column
              label="产品金额"
              min-width="80"
              prop="SellPrice"
          ></el-table-column>
          <el-table-column
              label="用户信息"
              min-width="120"
              prop="userInfo"
          >
            <template #default="scope">
              <div>姓名：{{scope.row.userInfo.name}}</div>
              <div>联系电话：{{scope.row.userInfo.phone}}</div>
              <div>邮箱：{{scope.row.userInfo.email}}</div>
              <div>邮编：{{scope.row.userInfo.postCode}}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="地址信息"
              min-width="120"
              prop="address"
          >
            <template #default="scope">
              <div>国家：{{scope.row.address.country}}</div>
              <div>省：{{scope.row.address.province}}</div>
              <div>市：{{scope.row.address.city}}</div>
              <div>区：{{scope.row.address.district}}</div>
              <div>详细地址：{{scope.row.address.street1}}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="状态"
              min-width="80"
              prop="status"
          >
            <template #default="scope">
              <span v-if="scope.row.status==0">待RII生成订单</span>
              <span v-if="scope.row.status==1">待下推卡派</span>
              <span v-if="scope.row.status==2">待上传文件</span>
              <span v-if="scope.row.status==3">待回传tp</span>
              <span v-if="scope.row.status==4">待回传马帮</span>
              <span v-if="scope.row.status==5">待上传出货凭证</span>
              <span v-if="scope.row.status==6">已完成</span>
            </template>
          </el-table-column>
          <el-table-column
              label="下载文件"
              min-width="100"
              prop="status"
          >
            <template #default="scope">
              <a target="_blank" :class="{'disabled-style':!scope.row.trackNumber}"  :href="scope.row.trackNumber ? 'https://copilot.maersk.com/webairbill/Reprint.aspx?section=ship&subsection=reprint&PrintWhat=Pro&Housebill='+scope.row.trackNumber+'&ShipperCountry=UN&ConsigneeCountry=UN' : 'javascript:void(0);' " >下载pro文件</a><br>
              <a target="_blank" :class="{'disabled-style':!scope.row.trackNumber}"  :href="scope.row.trackNumber ? 'https://copilot.maersk.com/webairbill/Reprint.aspx?section=ship&subsection=reprint&PrintWhat=Label&Housebill='+scope.row.trackNumber : 'javascript:void(0);' " >下载label文件</a>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              min-width="60"
              prop="addServices"
          >
            <template #default="scope">
              <el-button :disabled="scope.row.status!=0" link type="primary" size="small" @click="check(0,scope.row)">下推RII</el-button>
              <el-popconfirm
                  class="box-item"
                  title="确定取消RII发货么？"
                  placement="left-start"
                  @confirm="check(2,scope.row)"
              >
                <template #reference>
                  <el-button :disabled="scope.row.status!=1 && scope.row.status!=2" link type="primary" size="small">取消RII</el-button>
                </template>
              </el-popconfirm>
              <el-button :disabled="scope.row.status!=1" link type="primary" size="small" @click="check(1,scope.row)">下推卡派</el-button>
              <el-button :disabled="scope.row.status!=2" link type="primary" size="small" @click="check(3,scope.row)">上传面单</el-button>
              <el-button :disabled="scope.row.status!=3" link type="primary" size="small" @click="check(4,scope.row)">回传Tp</el-button>
              <el-button :disabled="scope.row.status!=4" link type="primary" size="small" @click="check(5,scope.row)">回传追踪号</el-button>
              <el-popconfirm
                  class="box-item"
                  title="确定马帮发货么？"
                  placement="left-start"
                  @confirm="check(6,scope.row)"
              >
                <template #reference>
                  <el-button :disabled="scope.row.status!=5" link type="primary" size="small">马帮发货</el-button>
                </template>
              </el-popconfirm>
              <el-button :disabled="scope.row.status!=6" link type="primary" size="small" @click="check(7,scope.row)">出货凭证</el-button>
              <span v-if="scope.row.status==7">已完成</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <addRIIForm ref="addRIIForm" @close="close"> </addRIIForm>
    <addCopilot ref="addCopilot" @close="close"> </addCopilot>
    <addRIIFile ref="addRIIFile" @close="close"> </addRIIFile>
    <addTeapplix ref="addTeapplix" @close="close"></addTeapplix>
    <addBbyMbErp ref="addBbyMbErp" @close="close"></addBbyMbErp>
    <addOutFile ref="addOutFile" @close="close"></addOutFile>
  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,
  ElTableColumn,ElPagination,ElSelect,ElOption,ElPopconfirm,ElMessage} from "element-plus";
import {bestbuy,delRIIBigStock,sendBbyMbErp,getMbNewOrder} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import MyImage from "@/components/myImage.vue";
import addRIIForm from "@/components/addRIIForm.vue";
import addRIIFile from "@/components/addRIIFile.vue";
import addTeapplix from "@/components/addTeapplix.vue";
import addBbyMbErp from "@/components/addBbyMbErp.vue";
import addOutFile from "@/components/addOutFile.vue";
import addCopilot from "@/components/addCopilot.vue";
export default {
  name: "bbyChannel",
  mixins:[DynamicHeightMixin],
  components: {
    MyImage,addRIIForm,addRIIFile,addTeapplix,addCopilot,
    ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,
    ElTableColumn,ElPagination,addBbyMbErp,ElSelect,ElOption,ElPopconfirm,
    addOutFile
  },
  data(){
    return{
      formInline:{
        startMonth: '',
        endMonth: ''
      },
      salePlatformList:[],
      order:"",
      tableData:[],
      inDate:0,
      outDate:0,
      repair:0,
      currentPage:1,
      pageSize:20,
      pageTotal:0,
      curData:{},
      loading: false,
      defaultOption:[
        {'label':'待RII生成订单',value:0},
        {'label':'卡派下运货单',value:1},
        {'label':'RII回传文件以及货运单号',value:2},
        {'label':'tp回传卡派货运单号',value:3},
        {'label':'马帮回传货运单',value:4},
        {'label':'马帮发货',value:5},
        {'label':'上传出货凭证',value:6},
        {'label':'已完成',value:7},
      ]
    }
  },
  beforeMount(){
    const date = new Date();
    date.setMonth(date.getMonth() - 3);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    this.formInline.startMonth = `${year}-${month}-${day}`;
    this.getAll()
  },
  methods:{
    getAll(){
      bestbuy({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage,orders:this.order} ).then((res)=>{
        this.tableData = res.Data.data
        this.pageTotal = res.Data.count
        this.inDate = res.Data.in_date
        this.outDate = res.Data.out_date
        this.repair = res.Data.repair
      }).catch((err)=>{
        console.log(err)
      })
    },
    fetchLatestOrders() {
      // 对销售订单号进行去前后空格处理
      if (this.formInline.saleOrder) {
        this.formInline.saleOrder = this.formInline.saleOrder.trim();
      }
      // 检查交易号是否为空
      if (!this.formInline.saleOrder) {
        ElMessage.warning("交易号不能为空");
        return;
      }
      
      this.loading = true;
      // 将查询条件中的销售订单号作为salesRecordNumbers参数传递
      const params = this.formInline.saleOrder ? { salesRecordNumbers: this.formInline.saleOrder } : {};
      getMbNewOrder(params).then(() => {
        ElMessage.success("拉取最新订单成功");
        this.getAll(); // 重新加载数据
      }).catch(err => {
        console.log(err);
        ElMessage.error("拉取最新订单失败");
      }).finally(() => {
        this.loading = false;
      });
    },
    delRIIBigStock(data){
      delRIIBigStock(data).then(res=>{
        console.log(res)
        this.getAll()
      }).catch(err=>{
        console.log(err)
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getAll();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getAll();
    },
    onSubmit(){
      this.PageNumber = 1
      // 对销售订单号进行去前后空格处理
      if (this.formInline.saleOrder) {
        this.formInline.saleOrder = this.formInline.saleOrder.trim();
      }
      this.getAll();
    },
    close(){
      this.getAll()
    },
    check(index,data){
      this.curData = data
      switch (index) {
        case 0:
          this.$refs.addRIIForm.open(data,"bby")
          break
        case 1:
          this.$refs.addCopilot.open(data)
          break
        case 2:
          this.delRIIBigStock({sendChannel:"bby",salesRecordNumber:data.salesRecordNumber,riiNumber:data.riiNumber})
          break
        case 3:
          this.$refs.addRIIFile.open(data,"bby")
          break
        case 4:
          this.$refs.addTeapplix.open(data)
          break
        case 5:
          this.$refs.addBbyMbErp.open(data)
          break
        case 6:
          sendBbyMbErp({trackNumber:data.trackNumber,riiNumber:data.riiNumber}).then(res=>{
            console.log(res)
            ElMessage.success("同步成功")
          }).catch(err=>{
            console.log(err)
          })
          break
        default:
          this.$refs.addOutFile.open(data)
          break
      }

    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-button+.el-button {
   margin-left: 0px;
}

.table-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px 0;
}
.disabled-style {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
  color: #999;
}
</style>